import { get, post } from './apiService';

const playerService = {
  /**
   * Fetch players with search and pagination
   * @param {Object} params - Search and pagination parameters
   * @param {number} params.Page - Current page number (1-based)
   * @param {number} params.TakeEntity - Number of items per page
   * @param {string} params.SearchTerm - Search term for filtering players
   * @returns {Promise<Object>} Response with players and pagination info
   */
  getPlayers: async (params = {}) => {
    const { Page = 1, TakeEntity = 20, SearchTerm = '' } = params;
    
    const queryParams = new URLSearchParams({
      Page: Page.toString(),
      TakeEntity: TakeEntity.toString(),
      ...(SearchTerm && { SearchTerm })
    });

    try {
      const response = await get(`admin/players?${queryParams}`);
      return response;
    } catch (error) {
      console.error('Error fetching players:', error);
      throw error;
    }
  },

  /**
   * Get player by ID
   * @param {string|number} playerId - Player ID
   * @returns {Promise<Object>} Player data
   */
  getPlayerById: async (playerId) => {
    try {
      const response = await get(`admin/players/${playerId}`);
      return response;
    } catch (error) {
      console.error('Error fetching player:', error);
      throw error;
    }
  },

  /**
   * Update player status or other properties
   * @param {string|number} playerId - Player ID
   * @param {Object} updateData - Data to update
   * @returns {Promise<Object>} Updated player data
   */
  updatePlayer: async (playerId, updateData) => {
    try {
      const response = await get(`admin/players/${playerId}/update`, { params: updateData });
      return response;
    } catch (error) {
      console.error('Error updating player:', error);
      throw error;
    }
  },

  /**
   * Charge player wallet
   * @param {Object} chargeData - Wallet charge data
   * @param {number} chargeData.PlayerId - Player ID
   * @param {number} chargeData.Amount - Amount to charge
   * @param {string} chargeData.Description - Description of the charge
   * @returns {Promise<any>} Response from charge operation
   */
  chargeWallet: async (chargeData) => {
    try {
      const response = await post('admin/players/charge-wallet', chargeData);
      return response;
    } catch (error) {
      console.error('Error charging wallet:', error);
      throw error;
    }
  }
};

export default playerService;
